import { InjectionToken, inject, provideAppInitializer } from '@angular/core';

declare global {
    interface Window {
        gtmDidInit?: boolean;
        dataLayer?: any[];
    }
}

interface IGTMSettings {
    gtmCode: string;
}

export const GTM_SETTINGS_TOKEN = new InjectionToken<IGTMSettings>('gtm-settings', {
    factory: () => ({ gtmCode: 'GTM-TKNR763' }),
});

export const provideGTM = (): any[] => [
    {
        provide: GTM_SETTINGS_TOKEN,
        useValue: { gtmCode: 'GTM-TKNR763' },
    },
    provideAppInitializer(() => {
        const initializerFn = gtmInitializer(inject(GTM_SETTINGS_TOKEN));
        return initializerFn();
    }),
];

export function gtmInitializer(settings: IGTMSettings): () => Promise<void> {
    return async () => {
        if (window.gtmDidInit) return;

        if (window.self !== window.top) {
            initGTM(settings.gtmCode);
        } else {
            document.addEventListener('DOMContentLoaded', () => delayGTMLoad(settings.gtmCode));
            document.addEventListener('scroll', (e) => initGTMOnEvent(e, settings.gtmCode));
            document.addEventListener('mousemove', (e) => initGTMOnEvent(e, settings.gtmCode));
            document.addEventListener('touchstart', (e) => initGTMOnEvent(e, settings.gtmCode));
        }
    };
}

function delayGTMLoad(gtmCode: string): void {
    setTimeout(() => initGTM(gtmCode), 10000);
}

function initGTMOnEvent(event: Event, gtmCode: string): void {
    initGTM(gtmCode);
    event.currentTarget?.removeEventListener(event.type, (e) => initGTMOnEvent(e, gtmCode));
}

function initGTM(gtmCode: string): void {
    if (window.gtmDidInit) return;

    console.log('GTM initializing at:', new Date().toISOString());
    window.gtmDidInit = true;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gtm.js',
            'gtm.start': new Date().getTime(),
            'gtm.uniqueEventId': 0,
        });
    };
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmCode}`;
    document.head.appendChild(script);
    console.debug('[Injectors][GtmInjector] Successfully injected.');
}
